import {
  aiInsightControllerSendPrompt,
  AiInsightControllerSendPromptData,
  ChatMessageDto
} from "@open-api";

export const aiController = {
  post: async (params: AiInsightControllerSendPromptData) => {
    const resp = await aiInsightControllerSendPrompt(params);
    return resp.data as ChatMessageDto;
  }
};
